/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function scan(params) {
    // 点淘App Hybrid：https://yuque.antfin-inc.com/ya8qsr/vzgrmn/gnivzc?#
    // JSBridge为TLCommonBridge.scan。 调用的是AliScanViewController。
    // 回调为 :{ @"type" : type,@"code" : code }
    var formatOutput = function (ret) {
        var qrCode = ret === null || ret === void 0 ? void 0 : ret.code;
        return {
            code: qrCode,
            qrCode: qrCode,
            barCode: qrCode,
        };
    };
    WVCall('TLCommonBridge.scan', params, {
        formatOutput: formatOutput,
    });
}

export { scan as default };
